
import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';
// 用户可用折扣列表
export default async function claimBenefitCode(context: Context, params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/benefit_code/member/claim', context.config.api.url);
  const { data: res } = await context.client.post(url.href, params);
  return res;
}
